
import { Visual } from "./visual";

/** test if the interface we have is a Circle */
export function isCircle(obj: any): obj is Circle {

  return (obj as Circle).isCircle !== undefined;
}

/**
 *
 * @class Circle
 *
 * specifies how to render some part of a canvas object.  The canvas adaptor we are
 * currently using must then render an appropriate object to the actual canvas.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export interface Circle extends Visual {

  /** type guard */
  isCircle: () => void;

  /** horizontal position */
  x?:               number;

  /** vertical position */
  y?:               number;

  /** horizontal extend */
  width?:           number;

  /** vertical extent */
  height?:          number;

  /** how big? */
  radius?:    number;

  /** the fill color */
  backgroundColor?: string;

  /** the stroke color */
  borderColor?:     string;

  /** the stroke width */
  borderWidth?:     number;

  /** drawn or not */
  visible?:         boolean;

  /** transparency (transparent) 0.0 ... 1.0 (not transparent) */
  opacity?:         number;

}
